import { createSelector } from 'reselect'

export const getBrands = createSelector(
  (state) => state && state.ads && state.ads.brands && state.ads.brands.elements && Array.isArray(state.ads.brands.elements)
    ? state.ads.brands.elements
    : [],
  (brands) => brands
)
